import { createCombinedAction } from '../helpers';

export const getAddress = createCombinedAction({ name: 'getAddress', prefix: 'address@@' });
export const removeAddress = createCombinedAction({ name: 'removeAddress', prefix: 'address@@' });
export const getAddressEdit = createCombinedAction({ name: 'getAddressEdit', prefix: 'address@@' });
export const addressEdit = createCombinedAction({ name: 'addressEdit', prefix: 'address@@' });
export const addressCreate = createCombinedAction({ name: 'addressCreate', prefix: 'address@@' });
